/**
 * RentListContainer
 * --
 */
import React, { useState, useEffect } from 'react';
// import ShippingList from 'routes/admin.routes/admin.orders/ShippingList';
import Presenter from './RentListPresenter';
import { RentalApi } from 'api';
import MessageAlert from 'utils';
import moment from 'moment';

const today = {
  start_date: moment().add(-90).startOf('day').unix(),
  end_date: moment().endOf('day').unix(),
};
const initialSearchFilter = {
  keywordType: 'shop_order_id',
  keyword: '',
  // dateType: 'today',
  dateType: 'week', // [today, week, month, 3month]
  startDate: null,
  endDate: null,
};

/**----------------------------------------
 * [Component] 배송내역 - 컨테이너
 * ----------------------------------------
 */
const RentListContainer = ({ defaultShopId, permission, type }) => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  const [loading, setLoading] = useState(false);
  const [orderList, setOrderList] = useState([]);
  const [searchFilter, setSearchFilter] = useState(initialSearchFilter);
  const [currentShop, setCurrentShop] = useState(defaultShopId ?? null);

  /* ===== VARIABLE ===== */

  /* ===== FUNCTION ===== */
  /**--------------------
   * 전체 주문내역 조회
   * --------------------
   */
  const getOrders = async (f = null) => {
    setLoading(true);
    try {
      const { status, message, data } = await RentalApi.getRentals({
        // start_date: today.start_date,
        // end_date: today.end_date,
        ...(currentShop && { shop_information_id: currentShop }),
        join_tables: `["user", "shop_information", "shop_order", "refund"]`,
      });
      if (status !== 200) throw { message };
      console.log('[RentListContainer][getOrders]data: ', data);

      setTimeout(() => {
        setOrderList(data);
        setLoading(false);
      }, 750);
    } catch (e) {
      setTimeout(() => {
        setLoading(false);
        MessageAlert.error(e.message);
      }, 2500);
    }
  };

  /* ===== HOOKS ===== */
  /*  */
  useEffect(() => {
    currentShop && getOrders();
  }, [currentShop]);

  /* ===== RENDER ===== */
  return (
    <>
      <Presenter
        {...{
          loading,
          permission,
          type: 'RENTAL',
          orderList,
          setCurrentShop,
        }}
      />
    </>
  );
};

/*  */
RentListContainer.defaultProps = {
  defaultShopId: null,
  type: null,
  permission: 'ADMIN',
};
export default RentListContainer;
